// import { useTranslation } from 'react-i18next';
import { CSSLiveBroadCast } from '../../types/model';
import LiveBroadcastCard from '../Card/LiveBroadcastCard';

// interface PropsType {
//   label: string;
//   title: string;
//   backgroundImage: {
//     src: string;
//     srcSet: string;
//     ratio: "square";
//   };
//   buttonText: string;
//   eventPath: string;
//   inSlideShow: boolean;
//   description: string;
// }

interface LiveBroadcastEventProps {
  event: CSSLiveBroadCast | null;
  slideShow: boolean;
}
const LiveBroadcastEvent: React.FC<LiveBroadcastEventProps> = ({ event, slideShow }) => {
  // const { t } = useTranslation();
  if (!event) {
    return null;
  }
  return (
    <>
    <LiveBroadcastCard
      label={event.label}
      title={event.title}
      backgroundImage={{
        src: event.backgroundImage,
        srcSet: event.backgroundImage,
        ratio: 'square',
      }}
      eventPath={event.linkToLiveBroadCast.toString()}
      inSlideShow={slideShow}
      description={event.description} buttonText={''}    />
      
      </>
  );
};

export default LiveBroadcastEvent;